import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets the window scroll position to the top of the page on every route change.
// Hash links (#section anchors) keep their normal browser behaviour.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};
